import gql from "graphql-tag"

export const GET_EXTERNAL_PRICE_CONFIG = gql`
  query getExternalPriceConfig($id: ID!) {
    getExternalPriceConfig(id: $id) {
      id
      baseUrl
      authUrl
      credentials {
        clientId
        clientSecret
      }
      created
      updated
    }
  }
`
